

<div class="card">
  <div class="card-content">

    <div class="stats-cards-row">
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ totalContractsCount }}</span>
          <span class="stats-card-label">Total Contracts</span>
          <span class="stats-card-sublabel">All contracts</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-file"></i></div>
      </div>
      <div class="stats-card stats-card--success">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ activeContractsCount }}</span>
          <span class="stats-card-label">Active</span>
          <span class="stats-card-sublabel">Currently active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-check-circle"></i></div>
      </div>
      <div class="stats-card stats-card--danger">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ inactiveContractsCount }}</span>
          <span class="stats-card-label">Inactive</span>
          <span class="stats-card-sublabel">Not active</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-minus-circle"></i></div>
      </div>
      <div class="stats-card stats-card--total">
        <div class="stats-card-main">
          <span class="stats-card-value">{{ showingCustomersCount }}</span>
          <span class="stats-card-label">Customers</span>
          <span class="stats-card-sublabel">After filters</span>
        </div>
        <div class="stats-card-icon"><i class="pi pi-users"></i></div>
      </div>
    </div>

    <div class="filter-bar filter-bar-collapsible mb-4" [class.filter-bar-visible]="pageHeaderService.currentFiltersVisible">
      <div class="filter-bar-filters">
        <div class="filter-field">
          <label for="statusFilter" class="filter-label">Status</label>
          <p-select id="statusFilter" [(ngModel)]="selectedStatus" (ngModelChange)="onStatusFilterChange()"
            [options]="statusOptions" optionLabel="label" optionValue="value" placeholder="All"
            [showClear]="true" [filter]="true" filterPlaceholder="Search status..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="customerFilter" class="filter-label">Customer</label>
          <p-select id="customerFilter" [(ngModel)]="selectedCustomerId" (ngModelChange)="onCustomerFilterChange()"
            [options]="clients" optionLabel="name" optionValue="id" placeholder="All customers"
            [showClear]="true" [filter]="true" filterPlaceholder="Search customer..."
            panelStyleClass="filter-dropdown-panel" appendTo="body" />
        </div>
        <div class="filter-field">
          <label for="durationValueFilter" class="filter-label">Duration</label>
          <div class="filter-field-split">
            <input id="durationValueFilter" type="number" pInputText [(ngModel)]="durationFilterValue"
              (ngModelChange)="onDurationFilterChange()" placeholder="Number" min="1" />
            <p-select id="durationUnitFilter" [(ngModel)]="durationFilterUnit" (ngModelChange)="onDurationFilterChange()"
              [options]="durationUnitOptions" optionLabel="label" optionValue="value" placeholder="Unit"
              [showClear]="true"
              panelStyleClass="filter-dropdown-panel" appendTo="body" />
          </div>
        </div>
      </div>
      <div class="filter-bar-actions">
        <button *ngIf="hasActiveFilters()" type="button" class="btn-clear-filters" (click)="clearFilters()" title="Clear all filters">
          <i class="pi pi-filter-slash"></i>
        </button>
      </div>
    </div>

    <!-- Loading -->
    <div *ngIf="loading" class="loading-container">
      <p>Loading contracts...</p>
    </div>

    <!-- Customer groups with expand/collapse -->
    <div *ngIf="!loading" class="customer-list">
      <div *ngFor="let customer of filteredCustomerGroups" class="customer-item">
        <div class="customer-header" (click)="toggleCustomer(customer)">
          <i class="pi mr-2" [ngClass]="customer.expanded ? 'pi-angle-down' : 'pi-angle-right'"></i>
          <span class="customer-name">{{ customer.clientName }}</span>
          <span class="customer-folder" *ngIf="customer.folderNumber">(Folder: {{ customer.folderNumber }})</span>
          <span class="contract-count">({{ customer.contracts.length }} Contract{{ customer.contracts.length !== 1 ? 's'
            : '' }})</span>
        </div>
        <div *ngIf="customer.expanded" class="contracts-table-wrapper">
          <!-- Client → MSA table (expand row) → linked SOW / Proposal / Schedule -->
          <div class="msa-table-section" *ngIf="customer.msaWithChildren.length > 0">
            <h4 class="section-title mb-2">MSA</h4>
            <p-table [value]="customer.msaWithChildren"
              [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
              styleClass="p-datatable no-column-lines compact-striped-table contracts-msa-table table-no-xscroll resize-handles-visible"
              [resizableColumns]="true" columnResizeMode="fit"
              [scrollable]="true" scrollHeight="400px">
              <ng-template pTemplate="header">
                <tr>
                  <th class="col-expand"></th>
                  <th class="col-msa-name" pResizableColumn>MSA Name</th>
                  <th class="col-service-group" pResizableColumn>Service Group</th>
                  <th class="col-company" pResizableColumn>Company</th>
                  <th class="col-country" pResizableColumn>Country</th>
                  <th class="col-status" pResizableColumn>Status</th>
                  <th class="col-date" pResizableColumn>Signed Date</th>
                  <th class="col-date" pResizableColumn>Effective Date</th>
                  <th class="col-duration" pResizableColumn>Duration</th>
                  <th class="col-date" pResizableColumn>Expiry Date</th>
                  <th class="col-child-count" pResizableColumn>SOW/Proposal</th>
                  <th class="col-actions">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-item>
                <tr class="msa-data-row">
                  <td (click)="toggleMsa(item)" class="expand-cell">
                    <i class="pi" [ngClass]="item.expanded ? 'pi-angle-down' : 'pi-angle-right'"></i>
                  </td>
                  <td [pTooltip]="item.msa.msaName" tooltipPosition="top" class="td-truncate">{{ item.msa.msaName || '—' }}</td>
                  <td [pTooltip]="item.msa.serviceGroupName" tooltipPosition="top" class="td-truncate">{{ item.msa.serviceGroupName }}</td>
                  <td [pTooltip]="item.msa.companyName" tooltipPosition="top" class="td-truncate">{{ item.msa.companyName || '—' }}</td>
                  <td [pTooltip]="item.msa.countryName" tooltipPosition="top" class="td-truncate">{{ item.msa.countryName || '—' }}</td>
                  <td><p-tag [value]="item.msa.status" [severity]="getStatusSeverity(item.msa.status)" /></td>
                  <td>{{ item.msa.msaSignedDate | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ (item.msa.effectiveDate | date: 'yyyy-MM-dd') || '—' }}</td>
                  <td>{{ item.msa.msaDuration || '—' }}</td>
                  <td>{{ item.msa.msaExpiryDate | date: 'yyyy-MM-dd' }}</td>
                  <td class="col-child-count text-center">
                    <p-tag *ngIf="item.children.length > 0" [value]="item.children.length.toString()" severity="secondary" />
                    <span *ngIf="item.children.length === 0" class="text-muted">—</span>
                  </td>
                  <td class="table-cell-actions">
                    <div class="table-actions-stack">
                      <p-button icon="pi pi-pencil" (onClick)="showEditDialog(item.msa); $event.stopPropagation()" [text]="true" severity="info" size="small" pTooltip="Edit" />
                      <p-button icon="pi pi-list" (onClick)="showContractDetails(item.msa); $event.stopPropagation()" [text]="true" severity="info" size="small" pTooltip="Details" />
                      <p-button icon="pi pi-history" (onClick)="showContractHistory(item.msa); $event.stopPropagation()" [text]="true" severity="info" size="small" pTooltip="History" />
                      <p-button icon="pi pi-briefcase" (onClick)="showJobsDialog(item.msa); $event.stopPropagation()" [text]="true" severity="info" size="small" pTooltip="Jobs" />
                    </div>
                  </td>
                </tr>
                <tr *ngIf="item.expanded" class="msa-expanded-row">
                  <td [attr.colspan]="12" class="expanded-cell">
                    <div class="msa-children">
                      <p-table *ngIf="item.children.length > 0" [value]="item.children"
                        [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
                        styleClass="p-datatable no-column-lines compact-striped-table nested-children-table contracts-child-table table-no-xscroll resize-handles-visible"
                        [resizableColumns]="true" columnResizeMode="fit"
                        [scrollable]="true" scrollHeight="300px">
                        <ng-template pTemplate="header">
                          <tr>
                            <th class="col-spacer"></th>
                            <th class="col-type" pResizableColumn>Type</th>
                            <th class="col-project-name" pResizableColumn>Project Name</th>
                            <th class="col-service-group" pResizableColumn>Service Group</th>
                            <th class="col-company" pResizableColumn>Company</th>
                            <th class="col-country" pResizableColumn>Country</th>
                            <th class="col-status" pResizableColumn>Status</th>
                            <th class="col-date" pResizableColumn>Signed Date</th>
                            <th class="col-date" pResizableColumn>Effective Date</th>
                            <th class="col-duration" pResizableColumn>Duration</th>
                            <th class="col-date" pResizableColumn>Expiry Date</th>
                            <th class="col-actions">Actions</th>
                          </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-row>
                          <tr>
                            <td class="col-spacer"></td>
                            <td><p-tag [value]="row.contractType || '—'" [severity]="getTypeSeverity(row.contractType)" /></td>
                            <td [pTooltip]="row.projectName" tooltipPosition="top" class="td-truncate">{{ row.projectName || '—' }}</td>
                            <td [pTooltip]="row.serviceGroupName" tooltipPosition="top" class="td-truncate">{{ row.serviceGroupName }}</td>
                            <td [pTooltip]="row.companyName" tooltipPosition="top" class="td-truncate">{{ row.companyName || '—' }}</td>
                            <td [pTooltip]="row.countryName" tooltipPosition="top" class="td-truncate">{{ row.countryName || '—' }}</td>
                            <td><p-tag [value]="row.status" [severity]="getStatusSeverity(row.status)" /></td>
                            <td>{{ (getDocumentSignedDate(row) | date: 'yyyy-MM-dd') || '—' }}</td>
                            <td>{{ (row.effectiveDate | date: 'yyyy-MM-dd') || '—' }}</td>
                            <td>{{ getDocumentDuration(row) }}</td>
                            <td>{{ (getDocumentExpiryDate(row) | date: 'yyyy-MM-dd') || '—' }}</td>
                            <td class="table-cell-actions">
                              <div class="table-actions-stack">
                                <p-button icon="pi pi-pencil" (onClick)="showEditDialog(row)" [text]="true" severity="info" size="small" pTooltip="Edit" />
                                <p-button icon="pi pi-list" (onClick)="showContractDetails(row)" [text]="true" severity="info" size="small" pTooltip="Details" />
                                <p-button icon="pi pi-history" (onClick)="showContractHistory(row)" [text]="true" severity="info" size="small" pTooltip="History" />
                                <p-button icon="pi pi-briefcase" (onClick)="showJobsDialog(row)" [text]="true" severity="info" size="small" pTooltip="Jobs" />
                              </div>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                      <div *ngIf="item.children.length === 0" class="empty-state empty-state--compact">
                        <div class="empty-icon"><i class="pi pi-link"></i></div>
                        <p class="empty-message">No linked contracts</p>
                        <p class="empty-description">No SOW, Proposal or Schedule is linked to this MSA.</p>
                      </div>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <!-- Standalone SOW/Proposal/Schedule (not linked to any MSA) -->
          <div class="standalone-section" *ngIf="customer.standaloneChildren.length > 0">
            <h4 class="section-title mb-2">Standalone (no MSA linked)</h4>
            <p-table [value]="customer.standaloneChildren"
              [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
              styleClass="p-datatable no-column-lines compact-striped-table contracts-child-table table-no-xscroll resize-handles-visible"
              [resizableColumns]="true" columnResizeMode="fit"
              [scrollable]="true" scrollHeight="300px">
              <ng-template pTemplate="header">
                <tr>
                  <th class="col-type" pResizableColumn>Type</th>
                  <th class="col-project-name" pResizableColumn>Project Name</th>
                  <th class="col-service-group" pResizableColumn>Service Group</th>
                  <th class="col-company" pResizableColumn>Company</th>
                  <th class="col-country" pResizableColumn>Country</th>
                  <th class="col-status" pResizableColumn>Status</th>
                  <th class="col-date" pResizableColumn>Signed Date</th>
                  <th class="col-date" pResizableColumn>Effective Date</th>
                  <th class="col-duration" pResizableColumn>Duration</th>
                  <th class="col-date" pResizableColumn>Expiry Date</th>
                  <th class="col-actions">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td><p-tag [value]="row.contractType || '—'" [severity]="getTypeSeverity(row.contractType)" /></td>
                  <td [pTooltip]="row.projectName" tooltipPosition="top" class="td-truncate">{{ row.projectName || '—' }}</td>
                  <td [pTooltip]="row.serviceGroupName" tooltipPosition="top" class="td-truncate">{{ row.serviceGroupName }}</td>
                  <td [pTooltip]="row.companyName" tooltipPosition="top" class="td-truncate">{{ row.companyName || '—' }}</td>
                  <td [pTooltip]="row.countryName" tooltipPosition="top" class="td-truncate">{{ row.countryName || '—' }}</td>
                  <td><p-tag [value]="row.status" [severity]="getStatusSeverity(row.status)" /></td>
                  <td>{{ (getDocumentSignedDate(row) | date: 'yyyy-MM-dd') || '—' }}</td>
                  <td>{{ (row.effectiveDate | date: 'yyyy-MM-dd') || '—' }}</td>
                  <td>{{ getDocumentDuration(row) }}</td>
                  <td>{{ (getDocumentExpiryDate(row) | date: 'yyyy-MM-dd') || '—' }}</td>
                  <td class="table-cell-actions">
                    <div class="table-actions-stack">
                      <p-button icon="pi pi-pencil" (onClick)="showEditDialog(row)" [text]="true" severity="info" size="small" pTooltip="Edit" />
                      <p-button icon="pi pi-list" (onClick)="showContractDetails(row)" [text]="true" severity="info" size="small" pTooltip="Details" />
                      <p-button icon="pi pi-history" (onClick)="showContractHistory(row)" [text]="true" severity="info" size="small" pTooltip="History" />
                      <p-button icon="pi pi-briefcase" (onClick)="showJobsDialog(row)" [text]="true" severity="info" size="small" pTooltip="Jobs" />
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div *ngIf="customer.expanded && customer.msaWithChildren.length === 0 && customer.standaloneChildren.length === 0 && customer.childContracts.length > 0"
               class="empty-state empty-state--compact">
            <div class="empty-icon"><i class="pi pi-file"></i></div>
            <p class="empty-message">No MSA for this client</p>
            <p class="empty-description">Add SOW, Proposal or Schedule under an MSA, or they appear in Standalone.</p>
          </div>

          <!-- Legacy: show flat list if no contractType split (all in contracts, none in msa/child) -->
          <div class="legacy-section" *ngIf="customer.expanded && customer.msaWithChildren.length === 0 && customer.standaloneChildren.length === 0 && customer.contracts.length > 0">
            <h4 class="section-title mb-2">Contracts</h4>
            <p-table [value]="customer.contracts"
              [tableStyle]="{ 'width': '100%', 'table-layout': 'fixed' }"
              styleClass="p-datatable no-column-lines compact-striped-table contracts-legacy-table table-no-xscroll resize-handles-visible"
              [resizableColumns]="true" columnResizeMode="fit"
              [scrollable]="true" scrollHeight="400px">
              <ng-template pTemplate="header">
                <tr>
                  <th class="col-folder" pResizableColumn>Folder#</th>
                  <th class="col-customer" pResizableColumn>Customer</th>
                  <th class="col-project-name" pResizableColumn>Project / Name</th>
                  <th class="col-service-group" pResizableColumn>Service Group</th>
                  <th class="col-country" pResizableColumn>Country</th>
                  <th class="col-status" pResizableColumn>Status</th>
                  <th class="col-date-sm" pResizableColumn>Effective</th>
                  <th class="col-date-sm" pResizableColumn>MSA Signed</th>
                  <th class="col-date-sm" pResizableColumn>MSA Expiry</th>
                  <th class="col-date-sm" pResizableColumn>SOW Signed</th>
                  <th class="col-date-sm" pResizableColumn>SOW Expiry</th>
                  <th class="col-date-sm" pResizableColumn>Proposal Signed</th>
                  <th class="col-date-sm" pResizableColumn>Proposal Expiry</th>
                  <th class="col-actions">Actions</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-row>
                <tr>
                  <td>{{ row.folderNumber || '-' }}</td>
                  <td [pTooltip]="row.clientName" tooltipPosition="top" class="td-truncate">{{ row.clientName }}</td>
                  <td [pTooltip]="row.projectName || row.msaName" tooltipPosition="top" class="td-truncate">{{ row.projectName || row.msaName || 'N/A' }}</td>
                  <td [pTooltip]="row.serviceGroupName" tooltipPosition="top" class="td-truncate">{{ row.serviceGroupName }}</td>
                  <td [pTooltip]="row.countryName" tooltipPosition="top" class="td-truncate">{{ row.countryName }}</td>
                  <td><p-tag [value]="row.status" [severity]="getStatusSeverity(row.status)" /></td>
                  <td>{{ (row.effectiveDate | date: 'yyyy-MM-dd') || '—' }}</td>
                  <td>{{ row.msaSignedDate | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.msaExpiryDate | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.sowSignedDate | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.sowExpiryDate | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.proposalSignedDate | date: 'yyyy-MM-dd' }}</td>
                  <td>{{ row.proposalExpiryDate | date: 'yyyy-MM-dd' }}</td>
                  <td class="table-cell-actions">
                    <div class="table-actions-stack">
                      <p-button icon="pi pi-pencil" (onClick)="showEditDialog(row)" [text]="true" severity="info" size="small" pTooltip="Edit" />
                      <p-button icon="pi pi-list" (onClick)="showContractDetails(row)" [text]="true" severity="info" size="small" pTooltip="Details" />
                      <p-button icon="pi pi-history" (onClick)="showContractHistory(row)" [text]="true" severity="info" size="small" pTooltip="History" />
                      <p-button icon="pi pi-briefcase" (onClick)="showJobsDialog(row)" [text]="true" severity="info" size="small" pTooltip="Jobs" />
                    </div>
                  </td>
                </tr>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr class="table-empty-row">
                  <td colspan="14" class="table-empty-cell">
                    <div class="empty-state empty-state--compact">
                      <div class="empty-icon"><i class="pi pi-inbox"></i></div>
                      <p class="empty-message">No contracts for this customer</p>
                    </div>
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </div>

          <div *ngIf="customer.expanded && customer.contracts.length === 0" class="empty-state empty-state--compact">
            <div class="empty-icon"><i class="pi pi-inbox"></i></div>
            <p class="empty-message">No contracts for this customer</p>
          </div>
        </div>
      </div>
      <div *ngIf="filteredCustomerGroups.length === 0" class="empty-state">
        <p>No contracts found.</p>
      </div>
    </div>
  </div>
</div>

<p-dialog [visible]="displayDialog" (visibleChange)="displayDialog = $event"
  [header]="dialogMode === 'add' ? 'Add Contract' : 'Edit Contract'" [modal]="true" styleClass="dialog-xl"
  [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact" *ngIf="selectedContract">
    <div class="form-dialog-container">
    <section class="form-section">
      <h4 class="section-title">Details</h4>
      <div class="form-grid form-grid-3">
        <div class="field" [class.field-invalid]="fieldTouched['clientId'] && !selectedContract.clientId">
          <label>Customer *</label>
          <p-select [(ngModel)]="selectedContract.clientId" (ngModelChange)="onClientChange()"
            (onChange)="onClientChange()" [options]="clients" optionLabel="name" optionValue="id"
            placeholder="Select customer" [showClear]="true" appendTo="body"
            (onBlur)="fieldTouched['clientId'] = true"
            panelStyleClass="filter-dropdown-panel" [filter]="true" filterPlaceholder="Search…" />
          <small class="field-hint" *ngIf="selectedContract.clientName">
            Customer: {{ selectedContract.clientName }}
          </small>
          <small class="field-error" *ngIf="fieldTouched['clientId'] && !selectedContract.clientId">Customer is required</small>
        </div>
        <div class="field">
          <label>Folder</label>
          <input pInputText [ngModel]="selectedContract.folderNumber || '—'" disabled
            placeholder="Select customer to show folder #" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['serviceGroupId'] && !selectedContract.serviceGroupId">
          <label>Service Group *</label>
          <p-select [(ngModel)]="selectedContract.serviceGroupId" (ngModelChange)="onServiceGroupChange()"
            (onChange)="onServiceGroupChange()" [options]="serviceGroups" optionLabel="name" optionValue="id"
            placeholder="Select service group" [showClear]="true" appendTo="body"
            (onBlur)="fieldTouched['serviceGroupId'] = true"
            panelStyleClass="filter-dropdown-panel" [filter]="true" filterPlaceholder="Search…" />
          <small class="field-error" *ngIf="fieldTouched['serviceGroupId'] && !selectedContract.serviceGroupId">Service group is required</small>
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['countryId'] && !selectedContract.countryId">
          <label>Country *</label>
          <p-select [(ngModel)]="selectedContract.countryId" (ngModelChange)="onCountryChange()"
            (onChange)="onCountryChange()" [options]="countries" optionLabel="name" optionValue="id"
            placeholder="Select country" [showClear]="true" appendTo="body"
            (onBlur)="fieldTouched['countryId'] = true"
            panelStyleClass="filter-dropdown-panel" [filter]="true" filterPlaceholder="Search…" />
          <small class="field-error" *ngIf="fieldTouched['countryId'] && !selectedContract.countryId">Country is required</small>
        </div>
        <div class="field">
          <label>Company</label>
          <p-select [(ngModel)]="selectedContract.companyId" (ngModelChange)="onCompanyChange()"
            (onChange)="onCompanyChange()" [options]="companies" optionLabel="name" optionValue="id"
            placeholder="Select company" [showClear]="true" appendTo="body"
            panelStyleClass="filter-dropdown-panel" [filter]="true" filterPlaceholder="Search…" />
        </div>
        <div class="field" [class.field-invalid]="fieldTouched['status'] && !selectedContract.status">
          <label>Status *</label>
          <p-select [(ngModel)]="selectedContract.status" [options]="statusOptionsWithoutAll" optionLabel="label"
            optionValue="value" placeholder="Select status" appendTo="body"
            (onBlur)="fieldTouched['status'] = true"
            panelStyleClass="filter-dropdown-panel" />
          <small class="field-error" *ngIf="fieldTouched['status'] && !selectedContract.status">Status is required</small>
        </div>
        <!-- Applies to every contract type, so it sits here rather than in a
             type-specific dates section below. -->
        <div class="field">
          <label>Effective Date</label>
          <p-datepicker [(ngModel)]="selectedContract.effectiveDate" dateFormat="yy-mm-dd" [showIcon]="true"
            [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
        <div class="field col-full" [class.field-invalid]="fieldTouched['contractType'] && !selectedContract.contractType">
          <label>Contract Type *</label>
          <p-select [(ngModel)]="selectedContract.contractType" (ngModelChange)="onContractTypeChange()"
            [options]="contractTypeOptions" optionLabel="label" optionValue="value"
            placeholder="Select type" appendTo="body"
            (onBlur)="fieldTouched['contractType'] = true"
            panelStyleClass="filter-dropdown-panel" />
          <small class="field-error" *ngIf="fieldTouched['contractType'] && !selectedContract.contractType">Contract type is required</small>
        </div>
      </div>
    </section>

    <section class="form-section" *ngIf="selectedContract.contractType === 'MSA'">
      <h4 class="section-title">MSA</h4>
      <div class="form-grid form-grid-2">
        <div class="field">
          <label>MSA Name</label>
          <input pInputText [(ngModel)]="selectedContract.msaName" placeholder="Enter MSA name" />
        </div>
      </div>
    </section>
    <section class="form-section" *ngIf="selectedContract.contractType === 'MSA'">
      <h4 class="section-title">MSA dates</h4>
      <div class="form-grid form-grid-3">
        <div class="field">
          <label>MSA Signed Date</label>
          <p-datepicker [(ngModel)]="selectedContract.msaSignedDate" dateFormat="yy-mm-dd" [showIcon]="true"
            [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
        <div class="field duration-row">
          <label>MSA Duration</label>
          <div class="duration-fields">
            <input type="number" pInputText [(ngModel)]="selectedContract.msaDurationValue" min="1" placeholder="Number"
              class="duration-number" />
            <p-select [(ngModel)]="selectedContract.msaDurationUnit" [options]="durationUnitOptions" optionLabel="label"
              optionValue="value" placeholder="Unit" styleClass="duration-unit" appendTo="body"
              panelStyleClass="filter-dropdown-panel" />
          </div>
        </div>
        <div class="field">
          <label>MSA Expiry Date</label>
          <p-datepicker [(ngModel)]="selectedContract.msaExpiryDate" dateFormat="yy-mm-dd" [showIcon]="true"
            [showButtonBar]="true" appendTo="body" [showOnFocus]="false" [autoZIndex]="true" />
        </div>
      </div>
    </section>
    <div class="field" *ngIf="selectedContract.contractType === 'MSA'">
      <label>MSA Notifications</label>
      <div class="flex align-items-center gap-2 mt-2">
        <p-checkbox id="disableMsaNotifications" [(ngModel)]="selectedContract.disableMsaNotifications"
          [binary]="true" />
        <label for="disableMsaNotifications" class="text-sm">Disable MSA Renewal Notifications</label>
      </div>
    </div>

    <section class="form-section" *ngIf="selectedContract.contractType === 'SOW' || selectedContract.contractType === 'Proposal' || selectedContract.contractType === 'Schedule'">
      <h4 class="section-title">{{ selectedContract.contractType }}</h4>
      <div class="form-grid form-grid-2">
        <div class="field">
          <label>Project Name</label>
          <input pInputText [(ngModel)]="selectedContract.projectName" placeholder="Enter project name" />
        </div>
        <div class="field">
          <label>Link to MSA (optional)</label>
          <p-select [(ngModel)]="selectedContract.parentMsaContractId" [options]="msaContractsForClient"
            optionLabel="msaName" optionValue="id" placeholder="Select MSA" [showClear]="true"
            appendTo="body" [filter]="true" filterPlaceholder="Search…" />
        </div>
      </div>
      <div class="form-grid form-grid-3 mt-2">
        <div class="field">
          <label>Signed Date</label>
          <p-datepicker *ngIf="selectedContract.contractType === 'SOW'" [(ngModel)]="selectedContract.sowSignedDate"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" appendTo="body" />
          <p-datepicker *ngIf="selectedContract.contractType === 'Schedule'" [(ngModel)]="selectedContract.scheduleSignedDate"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" appendTo="body" />
          <p-datepicker *ngIf="selectedContract.contractType === 'Proposal'" [(ngModel)]="selectedContract.proposalSignedDate"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" appendTo="body" />
        </div>
        <div class="field duration-row">
          <label>Duration</label>
          <div class="duration-fields" *ngIf="selectedContract.contractType === 'SOW'">
            <input type="number" pInputText [(ngModel)]="selectedContract.sowDurationValue" min="1" placeholder="Number" class="duration-number" />
            <p-select [(ngModel)]="selectedContract.sowDurationUnit" [options]="durationUnitOptions" optionLabel="label" optionValue="value" placeholder="Unit" styleClass="duration-unit" appendTo="body" />
          </div>
          <div class="duration-fields" *ngIf="selectedContract.contractType === 'Schedule'">
            <input type="number" pInputText [(ngModel)]="selectedContract.scheduleDurationValue" min="1" placeholder="Number" class="duration-number" />
            <p-select [(ngModel)]="selectedContract.scheduleDurationUnit" [options]="durationUnitOptions" optionLabel="label" optionValue="value" placeholder="Unit" styleClass="duration-unit" appendTo="body" />
          </div>
          <div class="duration-fields" *ngIf="selectedContract.contractType === 'Proposal'">
            <input type="number" pInputText [(ngModel)]="selectedContract.proposalDurationValue" min="1" placeholder="Number" class="duration-number" />
            <p-select [(ngModel)]="selectedContract.proposalDurationUnit" [options]="durationUnitOptions" optionLabel="label" optionValue="value" placeholder="Unit" styleClass="duration-unit" appendTo="body" />
          </div>
        </div>
        <div class="field">
          <label>Expiry Date</label>
          <p-datepicker *ngIf="selectedContract.contractType === 'SOW'" [(ngModel)]="selectedContract.sowExpiryDate"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" appendTo="body" />
          <p-datepicker *ngIf="selectedContract.contractType === 'Schedule'" [(ngModel)]="selectedContract.scheduleExpiryDate"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" appendTo="body" />
          <p-datepicker *ngIf="selectedContract.contractType === 'Proposal'" [(ngModel)]="selectedContract.proposalExpiryDate"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" appendTo="body" />
        </div>
      </div>
    </section>
    <section class="form-section">
      <div class="field">
        <label>Note</label>
        <textarea pInputTextarea [(ngModel)]="selectedContract.note" [rows]="4"
          placeholder="Optional note for this contract" class="w-full"></textarea>
      </div>
    </section>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideDialog()" severity="secondary" [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveContract()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>

<p-dialog [visible]="displayContractDetailsDialog" (visibleChange)="displayContractDetailsDialog = $event"
  header="Contract Details" [modal]="true" styleClass="dialog-xl contract-details-dialog"
  [dismissableMask]="true" [closable]="true">

  <div class="form-dialog-form form-dialog-compact" *ngIf="selectedContractForDetails">
    <div class="form-dialog-container">
    <!-- Which contract is being edited: read-only context, not part of the form -->
    <div class="contract-summary mb-4">
      <div class="contract-summary__head">
        <p-tag [value]="selectedContractForDetails.contractType || '—'"
          [severity]="getTypeSeverity(selectedContractForDetails.contractType || '')" />
        <span class="contract-summary__name">
          {{ selectedContractForDetails.contractType === 'MSA'
              ? (selectedContractForDetails.msaName || '—')
              : (selectedContractForDetails.projectName || 'N/A') }}
        </span>
      </div>
      <dl class="contract-summary__facts">
        <div>
          <dt>Customer</dt>
          <dd>{{ selectedContractForDetails.clientName }}</dd>
        </div>
        <div>
          <dt>Service Group</dt>
          <dd>{{ selectedContractForDetails.serviceGroupName }}</dd>
        </div>
        <div *ngIf="selectedContractForDetails.contractType !== 'MSA' && selectedContractForDetails.parentMsaName">
          <dt>Linked MSA</dt>
          <dd>{{ selectedContractForDetails.parentMsaName }}</dd>
        </div>
      </dl>
    </div>

    <!-- Grouped so related fields sit together: the price review cycle, then what the
         contract is worth, then its terms. Each pair on a row belongs to the same topic. -->

    <!-- Price Review: when it was last looked at and when it is next due -->
    <div class="form-section mb-4">
      <div class="form-section-title">Price Review</div>
      <div class="form-grid form-grid-2">
        <div class="field">
          <label for="lastPriceReviewed">Last Price Reviewed</label>
          <p-datepicker inputId="lastPriceReviewed" [(ngModel)]="contractDetails.lastPriceReviewed"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" [showOnFocus]="false"
            appendTo="body" />
          <small class="field-hint">Saving a new date records a price review.</small>
        </div>

        <div class="field">
          <label for="nextPriceRenewalDate">Next Price Renewal Date</label>
          <p-datepicker inputId="nextPriceRenewalDate" [(ngModel)]="contractDetails.nextPriceRenewalDate"
            dateFormat="yy-mm-dd" [showIcon]="true" [showButtonBar]="true" [showOnFocus]="false"
            appendTo="body" />
          <small class="field-warning" *ngIf="isNextRenewalBeforeLastReview()">
            <i class="pi pi-exclamation-triangle"></i>
            Earlier than the last review date.
          </small>
          <small class="field-hint" *ngIf="!isNextRenewalBeforeLastReview()">
            When the price is next due for review.
          </small>
        </div>

        <div class="field form-grid-span-2">
          <label for="priceReviewRemarks">{{ currentYear }} Price Review Remarks</label>
          <textarea id="priceReviewRemarks" pInputTextarea
            [(ngModel)]="contractDetails.priceReviewRemarks" rows="2"
            placeholder="Notes about this year's price review"></textarea>
        </div>
      </div>
    </div>

    <!-- Pricing: the rate and the charges derived from it -->
    <div class="form-section mb-4">
      <div class="form-section-title">Pricing</div>
      <div class="form-grid form-grid-2">
        <div class="field">
          <label for="price">Price</label>
          <input id="price" type="number" pInputText [(ngModel)]="contractDetails.price"
            placeholder="0.00" step="0.01" />
        </div>

        <div class="field">
          <label for="rateBase">Rate Base</label>
          <input id="rateBase" pInputText [(ngModel)]="contractDetails.rateBase"
            placeholder="e.g. Hourly, Monthly" />
        </div>

        <div class="field">
          <label for="btgServiceCharge">BTG Service Charge</label>
          <input id="btgServiceCharge" type="number" pInputText
            [(ngModel)]="contractDetails.btgServiceCharge" placeholder="0.00" step="0.01" />
        </div>

        <div class="field">
          <label for="btgServiceFee">BTG Service Fee</label>
          <input id="btgServiceFee" type="number" pInputText
            [(ngModel)]="contractDetails.btgServiceFee" placeholder="0.00" step="0.01" />
        </div>
      </div>
    </div>

    <!-- CPI: the escalation charge and the clause that governs it -->
    <div class="form-section mb-4">
      <div class="form-section-title">CPI Escalation</div>
      <div class="form-grid form-grid-2">
        <div class="field">
          <label for="cpiServiceCharge">CPI Service Charge</label>
          <input id="cpiServiceCharge" type="number" pInputText
            [(ngModel)]="contractDetails.cpiServiceCharge" placeholder="0.00" step="0.01" />
        </div>

        <div class="field">
          <label for="cpiClause">CPI Clause</label>
          <textarea id="cpiClause" pInputTextarea [(ngModel)]="contractDetails.cpiClause" rows="2"
            placeholder="Escalation terms"></textarea>
        </div>
      </div>
    </div>

    <!-- Contract Terms: how long it runs and how it ends -->
    <div class="form-section mb-4">
      <div class="form-section-title">Contract Terms</div>
      <div class="form-grid form-grid-2">
        <div class="field">
          <label>Contract Duration</label>
          <div class="duration-options">
            <div class="duration-option">
              <p-checkbox [(ngModel)]="contractDetails.contractLessThanOneYear" binary="true"
                inputId="contractLessThanOneYear" />
              <label for="contractLessThanOneYear">&lt; 1 Year</label>
            </div>
            <div class="duration-option">
              <p-checkbox [(ngModel)]="contractDetails.contractForOneYear" binary="true" inputId="contractForOneYear" />
              <label for="contractForOneYear">1 Year</label>
            </div>
            <div class="duration-option">
              <p-checkbox [(ngModel)]="contractDetails.contractGreaterThanOneYear" binary="true"
                inputId="contractGreaterThanOneYear" />
              <label for="contractGreaterThanOneYear">&gt; 1 Year</label>
            </div>
          </div>
        </div>

        <div class="field">
          <label for="terminationNoticeValue">Termination Notice Period</label>
          <div class="termination-notice">
            <input id="terminationNoticeValue" type="number" pInputText
              [(ngModel)]="contractDetails.terminationNoticePeriodValue"
              placeholder="Number" min="1" class="termination-notice-input" />
            <p-select [(ngModel)]="contractDetails.terminationNoticePeriodUnit"
              [options]="terminationNoticePeriodUnitOptions" optionLabel="label" optionValue="value"
              placeholder="Unit" styleClass="termination-notice-unit" appendTo="body" />
          </div>
        </div>
      </div>
    </div>

    <!-- Price Review History: one record per Last Price Reviewed date -->
    <div class="form-section mt-3 price-review-section">
      <div class="price-review-header" (click)="togglePriceReviews()">
        <i class="pi" [ngClass]="priceReviewsExpanded ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        <strong>Price Review History</strong>
        <i class="pi pi-info-circle table-info-icon"
          pTooltip="A review is recorded each time the Last Price Reviewed date changes. Saving without changing that date updates the current review instead. Select a review to see its full details."
          tooltipPosition="right" (click)="$event.stopPropagation()"></i>
        <span class="price-review-count" *ngIf="priceReviews.length">{{ priceReviews.length }}</span>
      </div>

      <div *ngIf="priceReviewsExpanded" class="price-review-body">
        <p *ngIf="loadingPriceReviews" class="text-secondary mb-0">Loading price reviews…</p>

        <table *ngIf="!loadingPriceReviews && priceReviews.length" class="price-review-table">
          <thead>
            <tr>
              <th class="pr-date">Reviewed Date</th>
              <th class="pr-date">Next Renewal</th>
              <th class="num pr-num">Price</th>
              <th class="num pr-num">Previous</th>
              <th class="num pr-num">Change</th>
              <th>Rate Base</th>
              <th>Updated By</th>
              <th class="num pr-view"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let review of priceReviews" class="price-review-row" (click)="openPriceReview(review)">
              <td>{{ review.reviewedDate | date: 'yyyy-MM-dd' }}</td>
              <td>{{ review.nextPriceRenewalDate ? (review.nextPriceRenewalDate | date: 'yyyy-MM-dd') : '—' }}</td>
              <td class="num">{{ review.price != null ? (review.price | number: '1.0-2') : '—' }}</td>
              <td class="num">{{ review.previousPrice != null ? (review.previousPrice | number: '1.0-2') : '—' }}</td>
              <td class="num" [ngClass]="{
                    'increment-up': incrementDirection(review) === 'up',
                    'increment-down': incrementDirection(review) === 'down'
                  }">
                <i class="pi" *ngIf="incrementDirection(review) as dir"
                  [ngClass]="dir === 'up' ? 'pi-arrow-up' : 'pi-arrow-down'"></i>
                {{ formatIncrement(review) }}
              </td>
              <td [pTooltip]="review.rateBase || '—'" tooltipPosition="top">{{ review.rateBase || '—' }}</td>
              <td [pTooltip]="review.changedBy || '—'" tooltipPosition="top">{{ review.changedBy || '—' }}</td>
              <td class="num">
                <i class="pi pi-eye price-review-view" pTooltip="View details" tooltipPosition="left"></i>
              </td>
            </tr>
          </tbody>
        </table>

        <p *ngIf="!loadingPriceReviews && !priceReviews.length" class="price-review-empty">
          No price reviews recorded yet.
        </p>
      </div>
    </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="History" icon="pi pi-history" (onClick)="showContractHistory(selectedContractForDetails!)" severity="secondary"
        [text]="true" *ngIf="selectedContractForDetails?.id" />
      <p-button label="Cancel" icon="pi pi-times" (onClick)="hideContractDetailsDialog()" severity="secondary"
        [outlined]="true" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveContractDetails()" severity="primary" />
    </div>
  </ng-template>
</p-dialog>

<!-- Price Review detail — READ ONLY -->
<p-dialog [visible]="displayPriceReviewDialog" (visibleChange)="displayPriceReviewDialog = $event"
  header="Price Review Details" [modal]="true" styleClass="dialog-lg" [dismissableMask]="true" [closable]="true"
  (onHide)="hidePriceReviewDialog()">
  <div *ngIf="selectedPriceReview as review" class="price-review-detail">
    <p class="price-review-detail__readonly">
      <i class="pi pi-lock"></i> Read only
    </p>

    <div class="price-review-detail__summary">
      <div class="price-review-detail__stat">
        <span class="label">Reviewed Date</span>
        <span class="value">{{ review.reviewedDate | date: 'yyyy-MM-dd' }}</span>
      </div>
      <div class="price-review-detail__stat">
        <span class="label">Next Renewal</span>
        <span class="value">{{ review.nextPriceRenewalDate ? (review.nextPriceRenewalDate | date: 'yyyy-MM-dd') : '—' }}</span>
      </div>
      <div class="price-review-detail__stat">
        <span class="label">Price</span>
        <span class="value">{{ review.price != null ? (review.price | number: '1.0-2') : '—' }}</span>
      </div>
      <div class="price-review-detail__stat">
        <span class="label">Previous Price</span>
        <span class="value">{{ review.previousPrice != null ? (review.previousPrice | number: '1.0-2') : '—' }}</span>
      </div>
      <div class="price-review-detail__stat">
        <span class="label">Price Increment</span>
        <span class="value" [ngClass]="{
              'increment-up': incrementDirection(review) === 'up',
              'increment-down': incrementDirection(review) === 'down'
            }">
          <i class="pi" *ngIf="incrementDirection(review) as dir"
            [ngClass]="dir === 'up' ? 'pi-arrow-up' : 'pi-arrow-down'"></i>
          {{ formatIncrement(review) }}
        </span>
      </div>
    </div>

    <table class="price-review-detail__table">
      <tbody>
        <tr><th>Rate Base</th><td>{{ review.rateBase || '—' }}</td></tr>
        <tr><th>BTG Service Charge</th><td>{{ review.btgServiceCharge != null ? (review.btgServiceCharge | number: '1.0-2') : '—' }}</td></tr>
        <tr><th>BTG Service Fee</th><td>{{ review.btgServiceFee != null ? (review.btgServiceFee | number: '1.0-2') : '—' }}</td></tr>
        <tr><th>CPI Service Charge</th><td>{{ review.cpiServiceCharge != null ? (review.cpiServiceCharge | number: '1.0-2') : '—' }}</td></tr>
        <tr><th>CPI Clause</th><td>{{ review.cpiClause || '—' }}</td></tr>
        <tr><th>Price Review Remarks</th><td>{{ review.priceReviewRemarks || '—' }}</td></tr>
        <tr><th>Termination Notice Period</th><td>{{ review.terminationNoticePeriod || '—' }}</td></tr>
        <tr>
          <th>Contract Duration</th>
          <td>
            <span *ngIf="review.contractLessThanOneYear">&lt; 1 Year</span>
            <span *ngIf="review.contractForOneYear">1 Year</span>
            <span *ngIf="review.contractGreaterThanOneYear">&gt; 1 Year</span>
            <span *ngIf="!review.contractLessThanOneYear && !review.contractForOneYear && !review.contractGreaterThanOneYear">—</span>
          </td>
        </tr>
        <tr><th>Recorded By</th><td>{{ review.changedBy || '—' }}</td></tr>
        <tr><th>Recorded On</th><td>{{ review.createdDate | date: 'yyyy-MM-dd HH:mm' }}</td></tr>
      </tbody>
    </table>

    <!-- Edits made to this review after it was created -->
    <div class="price-review-detail__trail" *ngIf="review.auditTrail?.length">
      <h4>Changes to this review</h4>
      <div class="price-review-detail__edit" *ngFor="let edit of review.auditTrail">
        <div class="price-review-detail__edit-head">
          {{ edit.changedAt | date: 'yyyy-MM-dd HH:mm' }} · {{ edit.changedBy || '—' }}
        </div>
        <table class="price-review-detail__table">
          <thead>
            <tr><th>Field</th><th>Previous</th><th>New</th></tr>
          </thead>
          <tbody>
            <tr *ngFor="let change of edit.changes">
              <td class="field">{{ change.field }}</td>
              <td class="old">{{ change.oldValue || '—' }}</td>
              <td class="new">{{ change.newValue || '—' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p class="price-review-detail__no-edits" *ngIf="!review.auditTrail?.length">
      No changes recorded since this review was created.
    </p>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="hidePriceReviewDialog()" severity="secondary" />
  </ng-template>
</p-dialog>

<!-- Contract/MSA History (Version history / audit log) -->
<p-dialog [visible]="displayHistoryDialog" (visibleChange)="displayHistoryDialog = $event"
  [header]="historyContract?.contractType === 'MSA' ? 'MSA History' : 'Contract History'"
  [modal]="true" styleClass="dialog-history" [dismissableMask]="true" [closable]="true"
  (onHide)="hideContractHistory()">
  <p *ngIf="historyContract" class="mb-3">
    <strong>{{ historyContract.contractType || 'Contract' }}</strong>
    {{ historyContract.msaName || historyContract.projectName || historyContract.clientName }}
  </p>
  <p *ngIf="loadingHistory" class="text-secondary">Loading history…</p>
  <p-table *ngIf="!loadingHistory" [value]="contractHistoryEntries"
    [tableStyle]="{ 'min-width': '100%' }"
    styleClass="p-datatable no-column-lines compact-striped-table resize-handles-visible"
    [resizableColumns]="true" columnResizeMode="fit">
    <ng-template pTemplate="header">
      <tr>
        <th class="hc-expand">
          <i class="pi pi-info-circle table-info-icon"
            pTooltip="Most recent change first. Select a row to see which fields changed."
            tooltipPosition="right"></i>
        </th>
        <th class="hc-version" pResizableColumn>Version</th>
        <th class="hc-date" pResizableColumn>Date &amp; Time</th>
        <th class="hc-user" pResizableColumn>User</th>
        <th class="hc-action" pResizableColumn>Action</th>
        <th class="hc-group" pResizableColumn>Service Group</th>
        <th class="hc-country" pResizableColumn>Country</th>
        <th class="hc-company" pResizableColumn>Company</th>
        <th class="hc-status" pResizableColumn>Status</th>
        <th class="hc-signed" pResizableColumn>Signed Date</th>
        <th class="hc-expiry" pResizableColumn>Expiry Date</th>
        <th class="hc-duration" pResizableColumn>Duration</th>
        <th class="hc-changed" pResizableColumn>Changed Fields</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-entry>
      <tr class="history-row" (click)="toggleHistoryDetail(entry)">
        <td>
          <i class="pi" [ngClass]="isHistoryDetailExpanded(entry) ? 'pi-chevron-down' : 'pi-chevron-right'"></i>
        </td>
        <td>{{ entry.version }}</td>
        <td>{{ entry.changedAt | date: 'yyyy-MM-dd HH:mm' }}</td>
        <td [pTooltip]="entry.changedBy || '—'" tooltipPosition="top">{{ entry.changedBy || '—' }}</td>
        <td>{{ entry.action }}</td>
        <td [pTooltip]="getHistoryServiceGroup(entry)" tooltipPosition="top">{{ getHistoryServiceGroup(entry) }}</td>
        <td [pTooltip]="getHistoryCountry(entry)" tooltipPosition="top">{{ getHistoryCountry(entry) }}</td>
        <td [pTooltip]="getHistoryCompany(entry)" tooltipPosition="top">{{ getHistoryCompany(entry) }}</td>
        <td>{{ getHistoryStatus(entry) }}</td>
        <td>{{ getHistorySignedDate(entry) }}</td>
        <td>{{ getHistoryExpiryDate(entry) }}</td>
        <td [pTooltip]="getHistoryDuration(entry)" tooltipPosition="top">{{ getHistoryDuration(entry) }}</td>
        <td [pTooltip]="getHistoryChangedSummary(entry)" tooltipPosition="top">{{ getHistoryChangedSummary(entry) }}</td>
      </tr>
      <tr *ngIf="isHistoryDetailExpanded(entry)" class="history-detail-row">
        <td colspan="13">
          <div class="history-detail">
            <h4 class="history-detail__title">
              {{ entry.action === 'Created' || entry.version === 1 ? 'Initial values' : 'Changes in this version' }}
            </h4>
            <table *ngIf="getHistoryChangeRows(entry).length" class="history-detail__table">
              <thead>
                <tr>
                  <th>Field</th>
                  <th>Previous</th>
                  <th>New</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let change of getHistoryChangeRows(entry)">
                  <td class="history-detail__field">{{ change.label }}</td>
                  <td class="history-detail__old">{{ change.previous }}</td>
                  <td class="history-detail__new">{{ change.current }}</td>
                </tr>
              </tbody>
            </table>
            <p *ngIf="!getHistoryChangeRows(entry).length" class="history-detail__empty">
              No field values changed in this version.
            </p>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr class="table-empty-row">
        <td colspan="13" class="table-empty-cell">
          <div class="empty-state empty-state--compact">
            <div class="empty-icon"><i class="pi pi-history"></i></div>
            <p class="empty-message">No history recorded</p>
            <p class="empty-description">Changes to this contract will appear here.</p>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="hideContractHistory()" severity="secondary" />
  </ng-template>
</p-dialog>

<!-- Jobs dialog: multiple priced jobs under one contract -->
<p-dialog [visible]="displayJobsDialog" (visibleChange)="displayJobsDialog = $event"
  header="Jobs" [modal]="true" styleClass="dialog-xl contract-jobs-dialog"
  [closable]="true" (onHide)="hideJobsDialog()">
  <div class="form-dialog-form form-dialog-compact">
    <div class="form-dialog-container">

      <div class="contract-summary" *ngIf="jobsContract">
        <dl class="contract-summary__facts">
          <div><dt>Customer</dt><dd>{{ jobsContract.clientName || '—' }}</dd></div>
          <div><dt>Project</dt><dd>{{ jobsContract.projectName || '—' }}</dd></div>
          <div><dt>Contract</dt><dd>{{ jobsContract.msaName || '—' }}</dd></div>
        </dl>
      </div>

      <div class="jobs-section">
        <div class="jobs-header">
          <span class="jobs-title">Jobs</span>
          <span class="jobs-count" *ngIf="jobs.length">{{ jobs.length }}</span>
          <p-button label="Add Job" icon="pi pi-plus" (onClick)="openJobForm()"
            [text]="true" severity="info" size="small" [disabled]="loadingJobs" />
        </div>

        <div class="jobs-loading" *ngIf="loadingJobs">Loading jobs…</div>

        <div class="empty-state empty-state--compact" *ngIf="!loadingJobs && jobs.length === 0">
          <div class="empty-icon"><i class="pi pi-briefcase"></i></div>
          <p class="empty-message">No jobs added</p>
          <p class="empty-description">Use "Add Job" to price a job under this contract.</p>
        </div>

        <table *ngIf="!loadingJobs && jobs.length" class="price-review-table jobs-table">
          <thead>
            <tr>
              <th>Job Name</th>
              <th class="num job-num">Price</th>
              <th class="job-date">Last Reviewed</th>
              <th class="job-date">Next Renewal</th>
              <th>Comments</th>
              <th class="num job-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let job of jobs" class="jobs-row">
              <td [pTooltip]="job.name || '—'" tooltipPosition="top">{{ job.name || '—' }}</td>
              <td class="num">{{ job.price != null ? (job.price | number: '1.0-2') : '—' }}</td>
              <td>{{ job.lastPriceReviewed ? (job.lastPriceReviewed | date: 'yyyy-MM-dd') : '—' }}</td>
              <td [ngClass]="{ 'job-renewal-due': isJobRenewalDue(job) }">
                <i class="pi pi-bell job-renewal-icon" *ngIf="isJobRenewalDue(job)"
                  pTooltip="Within the reminder window" tooltipPosition="top"></i>
                {{ job.nextPriceRenewalDate ? (job.nextPriceRenewalDate | date: 'yyyy-MM-dd') : '—' }}
              </td>
              <td [pTooltip]="job.comments || '—'" tooltipPosition="top">{{ job.comments || '—' }}</td>
              <td class="num">
                <div class="jobs-row__actions">
                  <p-button icon="pi pi-pencil" (onClick)="openJobForm(job)"
                    [text]="true" severity="info" size="small" pTooltip="Edit job" tooltipPosition="left" />
                  <p-button icon="pi pi-trash" (onClick)="confirmDeleteJob(job)"
                    [text]="true" severity="danger" size="small" pTooltip="Delete job" tooltipPosition="left" />
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div>
  </div>

  <ng-template pTemplate="footer">
    <p-button label="Close" icon="pi pi-times" (onClick)="hideJobsDialog()" severity="secondary" />
  </ng-template>
</p-dialog>

<!-- Add / Edit a single job. Saves on its own, so the Jobs list dialog stays read-only. -->
<p-dialog [visible]="displayJobFormDialog" (visibleChange)="displayJobFormDialog = $event"
  [header]="jobFormMode === 'add' ? 'Add Job' : 'Edit Job'" [modal]="true"
  styleClass="dialog-md contract-job-form-dialog" [closable]="true" (onHide)="hideJobForm()">
  <div class="form-dialog-form form-dialog-compact" *ngIf="jobForm">
    <div class="form-dialog-container">
      <div class="form-grid form-grid-2">
        <div class="field form-grid-span-2">
          <label for="jobName">Job Name <span class="required-mark">*</span></label>
          <input id="jobName" type="text" pInputText [(ngModel)]="jobForm.name"
            [ngModelOptions]="{ standalone: true }" placeholder="e.g. Dev Team A" maxlength="200" />
          <small class="field-warning" *ngIf="!jobForm.name.trim()">Job name is required.</small>
        </div>

        <div class="field">
          <label for="jobPrice">Price</label>
          <input id="jobPrice" type="number" pInputText [(ngModel)]="jobForm.price"
            [ngModelOptions]="{ standalone: true }" placeholder="0.00" step="0.01" />
        </div>

        <div class="field">
          <label for="jobReviewed">Last Price Reviewed</label>
          <p-datepicker inputId="jobReviewed" [(ngModel)]="jobForm.lastPriceReviewed"
            [ngModelOptions]="{ standalone: true }" dateFormat="yy-mm-dd"
            [showIcon]="true" [showButtonBar]="true" [showOnFocus]="false" appendTo="body" />
        </div>

        <div class="field form-grid-span-2">
          <label for="jobRenewal">Next Price Renewal Date</label>
          <p-datepicker inputId="jobRenewal" [(ngModel)]="jobForm.nextPriceRenewalDate"
            [ngModelOptions]="{ standalone: true }" dateFormat="yy-mm-dd"
            [showIcon]="true" [showButtonBar]="true" [showOnFocus]="false" appendTo="body" />
          <small class="field-warning" *ngIf="isJobRenewalBeforeReview(jobForm)">
            Renewal date is before the last review date.
          </small>
          <small class="field-hint" *ngIf="jobForm.nextPriceRenewalDate && !isJobRenewalBeforeReview(jobForm)">
            Reminders are sent 3 months, 1 month and 2 weeks before this date.
          </small>
        </div>

        <div class="field form-grid-span-2">
          <label for="jobComments">Comments</label>
          <textarea id="jobComments" pInputTextarea rows="3" [(ngModel)]="jobForm.comments"
            [ngModelOptions]="{ standalone: true }" placeholder="Optional notes for this job"></textarea>
        </div>
      </div>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <div class="form-dialog-footer-btns">
      <p-button label="Cancel" (onClick)="hideJobForm()" severity="secondary" [outlined]="true"
        [disabled]="savingJob" />
      <p-button label="Save" icon="pi pi-check" (onClick)="saveJob()" severity="primary"
        [disabled]="savingJob || !jobForm || !jobForm.name.trim()" />
    </div>
  </ng-template>
</p-dialog>

<p-confirmDialog />